export const TIMELINE_FALLBACK_LEAD_COEFFICIENT = 0.59
export const TIMELINE_CHOICES = [
  { value: 'specific_date', text: 'Yes, I have a specific date', lead_coefficient: 1.85 },
  { value: 'soon_next_1_to_2_months', text: 'No specific date, but soon (in the next 1-2 months)', lead_coefficient: 1.28 },
  { value: 'soon_within_6_months', text: 'No specific date, but sometime in the next 6 months', lead_coefficient: 1.45 },
  { value: 'within_12_months', text: 'Within the next 12 months', lead_coefficient: 1.1 },
  { value: 'over_a_year_from_now', text: 'Over a year from now', lead_coefficient: 0.5 },
  { value: 'just_looking', text: 'I\'m just looking for now', lead_coefficient: 0.5 },
]

export const RECIPIENT_CHOICES = [
  { value: 'S/O', text: 'My significant other', lead_coefficient: 1.19 },
  { value: 'me', text: 'Me', lead_coefficient: 1 },
]

export const INTENT_CHOICES = [
  { value: 'shopping_around', text: 'Shopping around', lead_coefficient: 0 },
  { value: 'buy_my_own', text: 'Planning to buy my own ring', lead_coefficient: 0.2 },
  { value: 'shopping_together', text: 'My S/O and I are shopping together', lead_coefficient: 0.21 },
]

export const SHIPPING_COUNTRY_CHOICES = [
  { value: 'United States', text: 'United States', engagement_lead_coefficient: 1.05, signet_lead_coefficient: 1.6, other_lead_coefficient: 1.1 },
  { value: 'Canada', text: 'Canada', engagement_lead_coefficient: 0.75, signet_lead_coefficient: 0.9, other_lead_coefficient: 0.8 },
  { value: 'United Kingdom', text: 'United Kingdom', engagement_lead_coefficient: 0.6, signet_lead_coefficient: 0.3, other_lead_coefficient: 0.4 },
  { value: 'Australia', text: 'Australia', engagement_lead_coefficient: 0.85, signet_lead_coefficient: 1.1, other_lead_coefficient: 0.4 },
  { value: 'Other', text: 'Other', engagement_lead_coefficient: 0.65, signet_lead_coefficient: 0.9, other_lead_coefficient: 1.0 },
]

export const CATEGORY_FALLBACK_COEFFICIENT = 37
export const CATEGORY_COEFFICIENTS = {
  signet_ring: 31,
  class_ring: 24,
  mens_wedding_band: 66,
  wedding_band_set: 66,
  womens_wedding_band: 66,
  cocktail_ring: 51,
  cufflinks: 71,
  earrings: 26,
  necklace: 28,
  lapelpin: 50,
  other_ring: 41
}
